import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import React from "react";
import SwiperCore, { A11y, Navigation, Pagination } from "swiper";
import { Swiper } from "swiper/react";
import styles from "./carousel-wrapper.module.css";
SwiperCore.use([
    Navigation,
    Pagination,
    A11y
]);
export var CarouselWrapper = function(param) {
    var children = param.children, _clickablePagination = param.clickablePagination, clickablePagination = _clickablePagination === void 0 ? true : _clickablePagination, _isCarouselReady = param.isCarouselReady, isCarouselReady = _isCarouselReady === void 0 ? true : _isCarouselReady, customClassNames = param.customClassNames, _ariaLabel = param.ariaLabel, ariaLabel = _ariaLabel === void 0 ? "carousel" : _ariaLabel, name = param.name, swiperSettings = param.swiperSettings;
    var a11yOptions = {
        enabled: true
    };
    var wrapperClassNames = cx(styles.carouselWrapper, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.wrapper, _define_property({}, styles.showCarousel, isCarouselReady));
    var carouselClassNames = cx(name, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.carousel);
    var paginationSettings = {
        el: ".".concat(name, "-pagination"),
        clickable: clickablePagination,
        dynamicBullets: true
    };
    var navigationSettings = {
        prevEl: ".".concat(name, "-prev"),
        nextEl: ".".concat(name, "-next")
    };
    return /*#__PURE__*/ _jsx("section", {
        className: wrapperClassNames,
        "aria-label": ariaLabel,
        children: /*#__PURE__*/ _jsx(Swiper, _object_spread_props(_object_spread({
            className: carouselClassNames,
            pagination: paginationSettings,
            a11y: a11yOptions,
            navigation: navigationSettings
        }, swiperSettings), {
            children: children
        }))
    });
};
export default CarouselWrapper;
